const BASE = process.env.PUBLIC_URL + '/img/';

const fotos = [
  {
    src: BASE + '470184828_567113332687674_6128873927785385124_n.jpg',
    caption: 'Material en almacén',
    large: true,
  },
  {
    src: BASE + '470214916_567697449295929_7413428222802893389_n.jpg',
    caption: 'Inventario disponible',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApp Image 2026-05-28 at 12.14.34 PM.jpeg',
    caption: 'Nuestro producto',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApp Image 2026-05-28 at 12.14.34 .jpeg',
    caption: 'Stock disponible',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApe 2026-05-28 at 12.14.35 PM.jpeg',
    caption: 'Materiales de calidad',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApp Ima026-05-28 at 12.14.34 PM.jpeg',
    caption: 'Amplio inventario',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApp Image 202-28 at 12.14.50 PM.jpeg',
    caption: 'Acero estructural',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApp Image 205-28 at 12.14.50 PM.jpeg',
    caption: 'Perfiles y tubería',
  },
];

const videos = [
  {
    src: BASE + 'WhatsApp Video 2026-06-02 at 11.29.33 AM.mp4',
    caption: 'Nuestro almacén',
  },

  {
    src: BASE + 'WhatsApp Video 2026-06-02 at 11.34.43 AM.mp4',
    caption: 'Productos disponibles',
  },
  {
    src: BASE + 'Nueva carpeta/WhatsApp Video 2026-05-28 at 12.14.49 PM.mp4',
    caption: 'Material en existencia',
  },
];

export default function Galeria() {
  return (
    <section className="galeria">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Nuestro material</p>
          <h2 className="section-title light">Nuestro Almacén</h2>
          <div className="section-divider" />
        </div>
      </div>

      <div className="galeria-grid">
        {fotos.map(({ src, caption, large }) => (
          <div key={src} className={`galeria-item${large ? ' large' : ''}`}>
            <img src={src} alt={caption} loading="lazy" />
            <div className="galeria-overlay">
              <span className="galeria-caption">{caption}</span>
            </div>
          </div>
        ))}

        {videos.map(({ src, caption }) => (
          <div key={src} className="galeria-item galeria-item--video">
            <video
              src={src}
              muted
              loop
              playsInline
              autoPlay
            />
            <div className="galeria-overlay">
              <span className="galeria-caption">{caption}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
